import React, { memo, useMemo } from 'react';
import { Text } from '@Sage/hoi-poi-ui';

const InfoRow = memo(({ label, value, content, rightContent }) => {
    const renderValue = useMemo(() => {
        if (!value) return null;
        if (Array.isArray(value)) {
            const values = value.map((current, index) => {
                return (
                    <Text key={index} className="info-row__value">
                        {current}
                        {index !== value.length - 1 && (
                            <span className="info-row__value--space">,</span>
                        )}
                    </Text>
                );
            });

            return <div className="info-row__multiple">{values}</div>;
        } else {
            return <Text className="info-row__value">{value}</Text>;
        }
    }, [value]);

    if (!label || (!value && !content && !rightContent)) return null;

    return (
        <div className="info-row">
            <div className="info-row--left">
                {(content || value) && <Text className="info-row__label">{label}:</Text>}
                {content && content}
                {!content && renderValue}
            </div>
            {rightContent && <div className="info-row--right">{rightContent}</div>}
        </div>
    );
});

export default InfoRow;
